import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Refresh } from "@material-ui/icons";
import axios from "axios";
import { FormControlLabel, Switch, withStyles } from "@material-ui/core";
import CreatePage, { Field } from "../../../components/CreatePage";
import Option from "../../../Models/forms/Option";
import PostCompany from "./models/PostCompany";
import setCompanyPostBody from "../../../store/company/actions/setCompanyPostBody";
import { UserUrls } from "../../UserManagement";
import Location, {
  defaultLocation,
} from "../../../Models/CommonProps/Location";
import useLocationInput from "../../../util/location/useLocationInput";
import CompanyDetails from "../../../Models/companies/Company";
import Contact, { defaultContact } from "../../../Models/CommonProps/Contact";
import useContactInput from "../../../util/contact/useContactInput";
import CertificationBodySelector from "../../../components/CertificationBodySelector";
import { isBRCGSAdmin, isCompanyUser,isBRCGSAdminForCompanyTier,proLiteCompany, isMegatronFeatureOn} from "../../../Authentication/Auth";
import { SharingOptionLabel } from "../../Sharing/components/AuditSharingOptions/SharingOptionsLabel";
import { number } from "../../../Enums/ValidationRule";
import { FieldValidator } from "../../../components/FieldValidator";
import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import SearchableDropdown from "../../../components/SearchableDropdown";

export const COMPANY_USER_ORIGIN = "company";

interface CompanyNewProps {
  readonly company?: CompanyDetails | null;
  readonly editOnlyFields?: Field[];
  readonly onSubmit?: (postBody: PostCompany) => Promise<any>;
}
const defaultVerifyLimitValue = async (): Promise<any> => {
  const response = await axiosApi.get<any>(
    `${BackendServices.COMPANY_SERVICE.COMPANY}/getVerifyFavouriteDefaultLimit`
  );
  return response.data.favouriteTagDefaultLimit;
};

const CompanyNew = ({
  company,
  editOnlyFields = [],
  onSubmit,
}: CompanyNewProps) => {
    useEffect(() => {
        fetchisMegatronFetaureOn(); 
        fetchVerifyDefaultLimit();
      },[company]);

  const isEditing = !!company;
  const [name, setName] = useState(company?.name ?? "");

  const [website, setWebsite] = useState(company?.website ?? "");
  const [contact, setContact] = useState<Contact>(
    company?.contact ?? { ...defaultContact }
  );
  const [certificationBody, setCertificationBody] = useState<Option | null>(
    null
  );
  const [location, setLocation] = useState<Location>(
    company?.location ?? { ...defaultLocation }
  );
  const locationFields = useLocationInput(location, setLocation);
  const contactFields = useContactInput(contact, setContact);

  const [type, setType] = useState(company?.type ?? "");

  const [blockSharing, setBlockSharing] = useState(
    company?.blockSharing ?? false
  );

  
  const [allowExportListValue, setAllowExportList] = useState(
    company?.allowExportList ?? true
  );  

  const [verifyTagLimit, setVerifyTagLimit] = useState<any>();
  const fetchVerifyDefaultLimit = async () => {
    const defaultVerifyLimit = await defaultVerifyLimitValue();
    const value = company?.favouriteLimit ?? defaultVerifyLimit;
    setVerifyTagLimit(value);
  };
  
    const [isMegatronFetaureOn, setisMegatronFetaureOn] = useState<boolean>(false);          
      const fetchisMegatronFetaureOn = async () => {
        const megatronFeature = await isMegatronFeatureOn();
        setisMegatronFetaureOn(megatronFeature);
      };
 const handleChangeTier = (value: Option | null) => {
    setType(value?.label || "");
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => 
   { 
     setAllowExportList(event.target.checked);
   }
  const AuditSwitch = withStyles({
    switchBase: {
      color: "white",
      "&$checked": {
        color: "#EA7600",
      },
      "&$checked + $track": {
        backgroundColor: "#EA7600",
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const dispatch = useDispatch();
  const history = useHistory();
  const fields: (Field | string)[] = [
    {
      name: "name",
      value: name,
      setTextValue: setName,
      label: "Company name",
      required: true,
      disabled: isCompanyUser(),
    },
    ...editOnlyFields,
    ...locationFields,
    ...contactFields,
    {
      name: "website",
      label: "Website",
      value: website,
      setTextValue: setWebsite,
      disabled: isCompanyUser(),
    },
    ...(!isEditing
      ? [
          {
            name: "cb",
            show: !isEditing,
            render: () => (
              <CertificationBodySelector
                value={certificationBody}
                onChange={setCertificationBody}
              />
            ),
          },
        ]
      : []),

    {
      name: "Verify tagging limit",
      value: verifyTagLimit,
      setTextValue: setVerifyTagLimit,
      label: "Verify tagging limit",
      validators: [FieldValidator.NUMBER],
      required: true,
      show: !isEditing && isBRCGSAdmin(),
      disabled:!isBRCGSAdmin(),
    }, 
    {
      name: "Prevent export list",
      show: !isEditing && isBRCGSAdmin(),     
      disabled:!isBRCGSAdmin(),
      render: () => (     
       <FormControlLabel
            control={
              <AuditSwitch checked={allowExportListValue} onChange={handleChange} /> //  id={`${Sharingid}`}
            }
            label="Prevent export list (Verify - Non Favourites)"
            labelPlacement="start"
          />         
      ),
    },
    {
      name: "companyTier",
      show: isEditing && isMegatronFetaureOn && isBRCGSAdminForCompanyTier(),
      disabled: !isBRCGSAdminForCompanyTier(),
      render: () => (
        <SearchableDropdown
          required
          name="companyTier"
          disabled={false}
          Options={[
            { label: proLiteCompany.Pro, value: proLiteCompany.Pro },
            { label: proLiteCompany.Lite, value: proLiteCompany.Lite },
          ]}
          label="Company Type "
          value={type ? { value: "", label: type } : null}
          onChange={(_, value) => handleChangeTier(value)}
        />
      ),
    },
    {
      name: "blockSharing",
      label: "Block Sharing",
      value: blockSharing,
      setBooleanValue: setBlockSharing,
      disabled: isCompanyUser(),
    },
  ];

  const mapToPostBody = (): PostCompany => {
    const cbId = certificationBody?.value;
    return {
      company: {
        name,
        blockSharing,
        website,
        location,
      },
      contact: { contactDetails: contact },
      certificationBodyExternalId: cbId ? parseInt(cbId as string, 10) : 0,
      allowExportList: !allowExportListValue,
      favouriteLimit: Number(verifyTagLimit),
      companyTier: type,
    };
  };

  const onPostSubmit = () => {
    if (!location?.country) return Promise.reject();    
    dispatch(setCompanyPostBody(mapToPostBody()));
    history.push(UserUrls.create({ origin: COMPANY_USER_ORIGIN }));
    return Promise.resolve();
  };

  return (
    <CreatePage
      title={!isEditing ? "Create Company" : "Edit Company"}
      fields={fields}
      onSubmit={onSubmit ? () => onSubmit(mapToPostBody()) : onPostSubmit}
    />
  );
};

export default CompanyNew;
